import {createSelector} from "@reduxjs/toolkit";
import rootSelector from "../rootSelector";

export const appConfigSelector = createSelector(rootSelector, s => s.appConfig);

export const appConfigDateFormatSelector = createSelector(appConfigSelector, s => s.dateFormat);
export const appConfigTimeFormatSelector = createSelector(appConfigSelector, s => s.timeFormat);
export const appConfigDateTimeFormatSelector = createSelector(appConfigSelector, s => s.dateTimeFormat);

export const appConfigMetadataViewModeSelector = createSelector(appConfigSelector, s => s.metadataViewMode);
